import React from 'react'

export const BackToTop = () => {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <div
      className="lg:hidden flex items-center justify-center gap-2 text-sm bg-white py-2 cursor-pointer"
      onClick={handleClick}
    >
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6629 16.5203C18.2968 16.8865 17.7032 16.8865 17.3371 16.5203L12 11.1832L6.66291 16.5203C6.2968 16.8865 5.7032 16.8865 5.33709 16.5203C4.97097 16.1542 4.97097 15.5606 5.33709 15.1945L11.3371 9.19451C11.7032 8.82839 12.2968 8.82839 12.6629 9.19451L18.6629 15.1945C19.029 15.5606 19.029 16.1542 18.6629 16.5203Z"
          fill="#6D6D6D"
        />
      </svg>
      <span>トップへ戻る</span>
    </div>
  )
}
